import { FontColorEnum, FormField, FormHint, FormLabel, TextArea } from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TInputAreaProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  bigSize?: boolean;
};

export function InputArea<T extends FieldValues>({
  form,
  name,
  required,
  disabled,
  label,
  placeholder,
  bigSize,
}: TInputAreaProps<T>) {
  const { t } = useTranslation();
  const { control } = form;
  const suffix = required ? '*' : '';

  return (
    <FormField>
      {label && (
        <FormLabel htmlFor={name}>
          {label}
          {suffix}
        </FormLabel>
      )}
      <Controller
        disabled={disabled}
        name={name}
        control={control}
        rules={{
          required: required ? { value: true, message: t('El campo es obligatorio') } : false,
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <TextArea
              disabled={disabled}
              value={value}
              placeholder={placeholder || label}
              onChange={e => {
                onChange(e);
              }}
              hasError={!!error}
              className={bigSize ? 'h-32' : ''}
            />
            {error && (
              <FormHint color={FontColorEnum.Error20} type="error">
                {error.message}
              </FormHint>
            )}
          </>
        )}
      />
    </FormField>
  );
}
